import { LogoUploadDispatcherModule } from './DI/LogoUploadDispatcherModule';
import { DILogoUploadTypes } from './DI/types';
import type { ILogoUploadDispatcherFactoryMethod } from './DI/interfaces';

export {
  LogoUploadDispatcherModule,
  type ILogoUploadDispatcherFactoryMethod as ILogoUploadDispatcherFactory,
};

export const { LogoUploadDispatcher } = DILogoUploadTypes;
